export const PAGINATION_SIZES = ['10', '20', '50', '100'] as const
export type ValidPaginationSize = (typeof PAGINATION_SIZES)[number]
